import type { Theme } from 'react-select';

export const reactSelectTheme = (theme: Theme): Theme => ({
  ...theme,
  borderRadius: 0,
  spacing: {
    ...theme.spacing,
    baseUnit: 2,
    controlHeight: 34,
  },
});
